module.exports = __webpack_public_path__ + "img/6.34fa5c27.jpg";